export default __webpack_public_path__ + "static/HU_Con_112_PCG1024_2-dda43d27587d530a04b2c6468b827abb.jpg";